import { jsxs, jsx } from "react/jsx-runtime";
import { LAYOUT } from "./constants.js";
function TitleQueture({ grade, unitLabel, unitName, quetureTitle, bleedPx = 0 }) {
  return /* @__PURE__ */ jsxs("div", { className: "absolute", style: { top: LAYOUT.title.top + bleedPx, left: bleedPx, right: bleedPx, zIndex: 1 }, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex gap-2 items-center", style: { marginLeft: LAYOUT.title.quetureMarginLeft }, children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          className: "font-dunggeunmiso shrink-0",
          style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#FFD000",
            borderRadius: 100,
            height: LAYOUT.title.gradeBadge.height,
            width: LAYOUT.title.gradeBadge.width,
            fontSize: LAYOUT.title.gradeBadge.fontSize,
            color: "#2B3B7A",
            fontWeight: 700
          },
          children: grade
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "font-dunggeunmiso", style: { fontSize: 20, color: "#2B3B7A", fontWeight: 700 }, children: unitLabel }),
      /* @__PURE__ */ jsx("span", { className: "font-dunggeunmiso", style: { fontSize: 20, color: "#2B3B7A", fontWeight: 700 }, children: unitName })
    ] }),
    /* @__PURE__ */ jsx(
      "p",
      {
        className: "font-dunggeunmiso",
        style: {
          fontSize: 48,
          color: "#2B3B7A",
          fontWeight: 700,
          lineHeight: 1.2,
          marginLeft: LAYOUT.title.quetureMarginLeft,
          marginTop: 16,
          letterSpacing: "-0.288px"
        },
        children: quetureTitle
      }
    )
  ] });
}
export {
  TitleQueture
};
//# sourceMappingURL=TitleQueture.js.map
